<template>
  <div
    v-click-outside="hideList"
    class="custom-select"
    style="width: 100%"
  >
    <AppInput type="text" class="main-input mb-5" icon="search" :input-value="inputValue" is-readonly
              :is-disabled="viewMode" @click="showList" @keydown="keydownHandler" />
    <div
      v-show="showPopUp"
      class="shadow-card select-popup"
    >
      <div class="options-box">
        <div v-for="option in questionOptions" :key="option.id" class="p-3"
             @click="answered(option.id, $event, false)">
          <input v-enter-to-tab :id="option.id" type="radio" :name="questionId" :checked="option.selected"
                 :value="option.name" :class="`m-2 align-middle ${showPopUp ? 'EnterToTab' : '' }`"
                 @click="answered(option.id, $event, true)" @keydown="keydownHandler" />
          <label class="align-middle m-0" :for="option.id">{{ option.name }}</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppInput from "../../AppInput.vue";

export default {
  'name': 'SelectionOption',
  components: { AppInput },
  'props': {
    'questionId': 0,
    'questionOptions': {},
    'viewMode': {
      'type': Boolean,
      'required': false
    }
  },
  data() {
    return {
      'showPopUp': false,
      'inputValue': ''
    }
  },
  watch: {
    questionOptions(newValue) {
      this.inputValue = '';
      for (const option of newValue) {
        if (option.selected) {
          this.inputValue = option.name;
        }
      }
    }
  },
  'methods': {
    response() {
      this.$emit('onAnswered')
    },
    answered(questionOptionId, e, fromInput) {
      e.stopPropagation()
      if(fromInput) return

      this.hideList()
      let selectedIndex;
      const questionOptions = this.questionOptions.map((option, index) => {
        if (option.id === questionOptionId) {
          selectedIndex = index;
          option.selected = true
          return { ...option, 'selected': true };
        } else {
          option.selected = false
          return { ...option, 'selected': false };
        }
      })
      this.$emit('onHideConditional', questionOptions, false)
      this.inputValue = questionOptions[selectedIndex].name;

      if (questionOptions[selectedIndex].conditional) {
        this.$emit('onShowConditional', questionOptions[selectedIndex], true)
      }
      this.$emit('onAnswered', questionOptions)
    },
    hideList() {
      this.showPopUp = false;
    },
    keydownHandler(event) {
      if(event.key === ' ') {
        this.showList()
      }
    },
    showList() {
      if (!this.viewMode) {
        if (this.showPopUp) {
          this.hideList()
        } else {
          this.showPopUp = true
        }
      }
    },
    checkConditionals() {
      this.questionOptions.forEach((option) => {
        if (option.conditional) {
          this.$emit('onShowConditional', option, option.selected)
        }
      })
    }
  },
  created() {
    const selectedQuestion = this.questionOptions.find((quest) => quest.selected);
    if (selectedQuestion) {
      this.inputValue = selectedQuestion.name;
    }
    this.checkConditionals()
  }
}

</script>
<style scoped>
.custom-select {
  position: relative;
  display: inline-block;
}

.main-input {
  cursor: pointer;
}

.select-popup {
  position:absolute;
  list-style: none;
  margin: -12px 0 0 0;
  top: 100%;
  left: 0;
  right: 0;
  background-color: white;
  border-radius: 4px;
  z-index: 2;
}

.options-box {
  max-height: 20em;
  overflow-y: scroll;
}
</style>
